<template>
    <v-dialog 
        v-model="showRegionDialog"
        width="650"
        persistent
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-on="on"
                hide-details
                readonly
                v-model="getRegionsString"
                :label="$t(label)"
                :alvqa="activatorAlvqa"
                :class="classes"
            ></v-text-field>
        </template>
        <v-card min-height="300" max-height="400" color="dialogStandardBackground">
            <v-toolbar color="dialogStandardHeaderBackground">
                <v-toolbar-title 
                    :alvqa="alvqa + '-title'"
                    class="dialogStandardHeadlineText--text"
                >{{ $t('lang_GENERAL_CAPTION_REGIONS') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="mt-4">
                    <BaseIcon
                        icon="close"
                        color="iconCancel"
                        @click="closeDialog"
                        :alvqa="alvqa + '-icon-close'"
                    ></BaseIcon>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <BaseRegions 
                        context="RegionDialog" 
                        includeCols="6"
                        excludeCols="6"
                        cols="6"
                        :alvqa="alvqa"
                        justify="space-around"
                    />
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container fluid >
                    <v-row>
                        <v-spacer />
                        <v-col class="text-right">
                            <BaseButton 
                                label="lang_GENERAL_CONFIRM"
                                @click="submit"
                                :alvqa="alvqa + '-button-submit'"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import BaseRegions from '@/components/_base/BaseRegions'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "RegionsDialog",
    components: {
      BaseRegions,
      BaseIcon,
      BaseButton
    },
    props: {
        context: String,
        label: {
            default: 'lang_GENERAL_CAPTION_REGIONS',
            type: String
        },
        classes: String,
        activatorAlvqa: {
            default: 'label-statistics-textfield-regions',
            type: String,
        },
        alvqa: {
            default: 'dialog-regions',
            type: String,
        },
        // use this object, when there are multiple regions in that context, 
        // e.g. shares in publishing contract, to identify which regions are need to be changed.
        rowRegions: {
            type: Object,
            default: null    
        }, 
    },
    computed: {
        showRegionDialog: {
            get() { return this.$store.getters.getShowRegionDialog },
            set(show) { this.$store.commit('setShowRegionDialog', show)}
        },

        originalInclude: {
            get() { return this.$store.getters['getSelected' + this.context + 'Regions'].include },
            set(includes) { this.$store.commit('setSelected' + this.context + 'RegionsInclude', includes) }
        },
        originalExclude: {
            get() { return this.$store.getters['getSelected' + this.context + 'Regions'].exclude },
            set(exclude) { this.$store.commit('setSelected' + this.context + 'RegionsExclude', exclude) }
        },
        getRegionsString:{
            get() { return this.$store.getters['getSelected' + this.context + 'RegionsString'] },
            set(value) { this.$store.commit('setSelected' + this.context + 'RegionsString', value) },
        },
    },
    methods: {
        closeDialog() {
            if(this.rowRegions !== null) {
                this.$store.commit('setRegionDialogDetailsInclude', JSON.parse(JSON.stringify(this.rowRegions.include)))
                // this.$store.commit('setRegionDialogDetailsInclude', [])
                this.$store.commit('setRegionDialogDetailsExclude', JSON.parse(JSON.stringify(this.rowRegions.exclude)))
                // this.$store.commit('setRegionDialogDetailsExclude', [])
            } else {
                this.$store.commit('setRegionDialogDetailsInclude', JSON.parse(JSON.stringify(this.originalInclude)))
                this.$store.commit('setRegionDialogDetailsExclude', JSON.parse(JSON.stringify(this.originalExclude)))
            }
            this.showRegionDialog = false
        },
        submit() {
            if(this.rowRegions !== null) {
                this.rowRegions.include = JSON.parse(JSON.stringify(this.$store.getters.getRegionDialogDetailsInclude))
                this.rowRegions.exclude = JSON.parse(JSON.stringify(this.$store.getters.getRegionDialogDetailsExclude))
            } else {
                this.$store.commit('setSelected' + this.context + 'RegionsInclude', JSON.parse(JSON.stringify(this.$store.getters.getRegionDialogDetailsInclude)))
                this.$store.commit('setSelected' + this.context + 'RegionsExclude', JSON.parse(JSON.stringify(this.$store.getters.getRegionDialogDetailsExclude)))
            }
            let regionsString = this.$alvPlugin.createRegionsToString(this.$store.getters['getSelected' + this.context + 'Regions'])
            this.getRegionsString = regionsString
            this.showRegionDialog = false
        }
    },
    created() {
        // make a deep copy, in case user clicks the X, so the original data is not changed
        // only after clicking the save button in the dialog
        let includes = []
        let excludes = []

        if(this.rowRegions !== null) {
            includes = JSON.parse(JSON.stringify(this.rowRegions.include))
            excludes = JSON.parse(JSON.stringify(this.rowRegions.exclude))
        } else {
            includes = JSON.parse(JSON.stringify(this.originalInclude))
            excludes = JSON.parse(JSON.stringify(this.originalExclude))
        }
        this.$store.commit('setRegionDialogDetailsInclude', includes)
        this.$store.commit('setRegionDialogDetailsExclude', excludes)
    }
}
</script>